import { AppBar, Tabs, Tab } from '@mui/material';
import { useQuery } from 'react-query';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC, useEffect, useState, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Page, PageTitleWithBack } from '../../../components';
import { getPartGeneralInfo } from '../../../fetch';
import { IPartGeneralInfo } from '../../../models';
import { GeneralInformation } from './general-information';

export const enum partPages {
  genInfo
}
interface IEditPart {}

export const EditPart: FC<IEditPart> = () => {
  const classes = useStyles();
  const [selectedPage, setSelectedPage] = useState<partPages>(partPages.genInfo);
  const [selectedTab, setSelectedTab] = useState(window.location.pathname);
  const [isDirtyForm, setDirtyForm] = useState<boolean>(false);
  const { partId }: { partId: string } = useParams();
  const history = useHistory();

  const {
    isLoading: isLoadingGeneralInfo,
    data: generalInfo,
    refetch: refetchGeneralInfo
  } = useQuery<IPartGeneralInfo, Error>(['part-general-info', partId], () =>
    getPartGeneralInfo(partId)
  );

  useEffect(() => {
    if (window.location.href.includes('general-information')) {
      setSelectedPage(partPages.genInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href, partId]);

  const getPartId = () => {
    return partId ? partId : 'add';
  };
  
  const partLinks = useMemo(
    () =>
      [
        {
          name: 'General Information',
          url: `/development/parts/manage-parts/${getPartId()}/general-information`
        }
      ].filter(Boolean),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [partId]
  );

  const showLoader = isLoadingGeneralInfo;
  const title = showLoader ? 'Loading...' : `Edit: ${generalInfo?.name}`;

  return (
    <Page title={title}>
      <>
        <PageTitleWithBack
          title={title}
          backText="Back to parts"
          backUrl="/development/parts/manage-parts"
        />
        {partId !== 'add' && (
          <AppBar position="static" color="default" component="div" className={classes.tabBar}>
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(_, value) => {
                if (!isDirtyForm) {
                  setSelectedTab(value);
                  history.push(value);
                } else {
                  const result = window.confirm(
                    'You have unsaved changes, are you sure you want to exit?'
                  );
                  if (result) {
                    setSelectedTab(value);
                    history.push(value);
                  } else {
                    return;
                  }
                }
              }}
              variant="scrollable"
            >
              {partLinks.map(link => {
                return (
                  <Tab
                    value={link.url}
                    key={link.name}
                    id={`${link.name}-information`}
                    aria-controls={`${link.name}-information`}
                    label={link.name}
                  />
                );
              })}
            </Tabs>
          </AppBar>
        )}
        {selectedPage === partPages.genInfo && (
          <GeneralInformation
            setDirtyForm={setDirtyForm}
            generalInfo={generalInfo}
            isLoadingGeneralInfo={isLoadingGeneralInfo}
            refetchGeneralInfo={refetchGeneralInfo}
          />
        )}
      </>
    </Page>
  );
};

const useStyles = makeStyles(theme => ({
  tabBar: {
    marginTop: '-1rem',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  }
}));
